import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getToken } from '../../utils/auth';
import axios from 'axios';
import CONFIG from '../../config';

/**
 * UI for generating a public communication channel identifier.
 * Uses the server endpoint POST /api/messaging/generate-id which
 * returns a publicId that can be shared safely.
 */
const CommunicationChannel = () => {
    const { t
        // , i18n
    } = useTranslation();
    // const isArabic = i18n.language?.startsWith('ar');
    const [hostname, setHostname] = useState('');
    const [userId, setUserId] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleGenerate = async () => {
        setLoading(true);
        setError('');
        try {
            const token = getToken();
            const res = await axios.post(
                `${CONFIG.API_URL}/api/messaging/generate-id`,
                { hostname, userId },
                { headers: token ? { Authorization: `Bearer ${token}` } : {} }
            );
            setResult(res.data);
        } catch (e) {
            console.error(e);
            setError(e.response?.data?.message || 'Failed to generate channel');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto my-12 p-8 bg-white rounded-[30px] shadow-2xl border border-gray-100">
            <h2 className="text-3xl font-black mb-6 text-gray-900">
                {t('admin.communication_channel.title', 'Create Communication Channel')}
            </h2>
            <div className="grid gap-4">
                <input
                    type="text"
                    placeholder={t('admin.communication_channel.hostname', 'Hostname')}
                    value={hostname}
                    onChange={e => setHostname(e.target.value)}
                    className="p-4 border rounded-xl focus:ring-2 focus:ring-brand-primary/20"
                />
                <input
                    type="text"
                    placeholder={t('admin.communication_channel.user_id', 'User ID')}
                    value={userId}
                    onChange={e => setUserId(e.target.value)}
                    className="p-4 border rounded-xl focus:ring-2 focus:ring-brand-primary/20"
                />
                <button
                    onClick={handleGenerate}
                    disabled={loading || !hostname || !userId}
                    className="px-6 py-3 bg-brand-primary text-white rounded-xl font-bold hover:bg-brand-primary/90 transition"
                >
                    {loading ? t('admin.communication_channel.generating', 'Generating...') : t('admin.communication_channel.generate', 'Generate')}
                </button>
            </div>
            {error && (
                <p className="mt-4 text-red-600">{error}</p>
            )}
            {result && (
                <div className="mt-6 p-4 bg-gray-50 rounded-xl">
                    <p className="font-medium">{t('admin.communication_channel.public_id', 'Public ID')}:</p>
                    <code className="block mt-2 text-sm">{result.publicId}</code>
                    <p className="mt-2 text-sm text-gray-600">
                        {t('admin.communication_channel.share_public_id', 'Share this public ID with your users. They will use it to start a conversation with you.')}
                    </p>
                </div>
            )}
        </div>
    );
}

export default CommunicationChannel;